import { Empty, Space, Table } from "antd";
import { vehicleTestResultApiUrl } from "../../../../../Common/endpoints";
import { getApis } from "../../../../../Common/apis";
import {
  setDynoPaginationDetails,
  setDynoResult,
} from "../../../../../../reducers/eolTestsSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  calculateDuration,
  formatShortDateAndTime,
} from "../../../../../Common/Utils";

const DynoTests = () => {
  const dispatch = useDispatch();
  const eol = useSelector((state) => state?.eolTests);
  const dynoHistoryData = eol?.dynoHistoryData;
  const authToken = localStorage.getItem("authToken");
  const paginationDetails = eol?.dynoPaginationDetails;
  const totalDynoElements = eol?.totalDynoElements;

  const columns = [
    {
      title: "Test#",
      dataIndex: "iteration",
      key: "iteration",
    },
    {
      title: "Start Time",
      dataIndex: "startTime",
      key: "startTime",
      render: (startTime) => formatShortDateAndTime(startTime),
    },
    {
      title: "End Time",
      dataIndex: "stopTime",
      key: "stopTime",
      render: (stopTime) => formatShortDateAndTime(stopTime),
    },
    {
      title: "Duration",
      dataIndex: "testDuration",
      key: "testDuration",
      render: (_, record) => calculateDuration(record),
    },
    {
      title: "Comment",
      dataIndex: "comment",
      key: "comment",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Link className="play" onClick={() => handleButtonClick(record)}>
            View
          </Link>
        </Space>
      ),
    },
  ];

  const handleButtonClick = async (record) => {
    const response = await getApis(
      vehicleTestResultApiUrl,
      {
        testId: record?.testId,
        vIdVal: record?.vehId,
      },
      authToken
    );
    dispatch(setDynoResult(response?.data));
  };

  const handlePageChange = (pagination) => {
    dispatch(
      setDynoPaginationDetails({
        current: pagination.current,
        pageSize: pagination.pageSize,
      })
    );
  };

  return dynoHistoryData?.length > 0 ? (
    <Table
      columns={columns}
      dataSource={dynoHistoryData}
      rowKey={(record) => record.iteration}
      scroll={{ x: "100%" }}
      onChange={handlePageChange}
      pagination={{
        current: paginationDetails.current,
        pageSize: paginationDetails.pageSize,
        total: totalDynoElements,
        showSizeChanger: false,
        showQuickJumper: false,
        hideOnSinglePage: true,
      }}
    />
  ) : (
    <div className="pd3025">
      <Empty />
    </div>
  );
};
export default DynoTests;
